module.exports = __webpack_public_path__ + "img/cancel-icon.1c7d5c56.svg";